import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInvoiceItems = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.24365 3.42765H8.66748C8.93268 3.42765 9.18698 3.5331 9.37451 3.72062L11.5142 5.86027C11.7016 6.04778 11.8071 6.30218 11.8071 6.5673V13.4999C11.8071 14.0521 11.3593 14.4998 10.8071 14.4999H3.24365C2.69137 14.4999 2.24365 14.0522 2.24365 13.4999V4.42765C2.24365 3.87537 2.69137 3.42765 3.24365 3.42765Z",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.62304 11.1443C4.75562 11.3187 4.92835 11.4585 5.12654 11.5518C5.32473 11.6452 5.54253 11.6893 5.76142 11.6804C6.45927 11.6804 7.0254 11.2558 7.0254 10.7326C7.0254 10.2093 6.45927 9.78474 5.76142 9.78474C5.06356 9.78474 4.49805 9.36014 4.49805 8.83629C4.49805 8.31244 5.06356 7.88846 5.76142 7.88846C5.98029 7.87975 6.19803 7.92392 6.3962 8.01724C6.59436 8.11057 6.76711 8.25029 6.8998 8.42457",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.76074 11.6839V12.3156",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.76074 7.26133V7.8924",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.7207 1.55668L8.7533 1.55668C9.52717 1.55668 10.2711 1.85573 10.8297 2.39134L12.8356 4.31489C13.4256 4.88066 13.7592 5.6627 13.7593 6.48015L13.7594 12.6907",
			stroke: "currentColor",
			strokeLinecap: "round"
		})
	]
});
export default SvgInvoiceItems;
